import React from 'react';
import CategoryList from 'components/category-list';
import { styled } from 'themes';
import { useStaticQuery, graphql } from 'gatsby';
import { device } from 'themes/media-queries';
import { useTranslation } from 'react-i18next';

const CategorySection = () => {
  const [t] = useTranslation();
  const images = useStaticQuery(graphql`
    query {
      babysitting: imageSharp(
        fluid: { originalName: { regex: "/babysitting.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
      gardening: imageSharp(
        fluid: { originalName: { regex: "/gardening.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
      event: imageSharp(
        fluid: { originalName: { regex: "/event.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
      homework: imageSharp(
        fluid: { originalName: { regex: "/homework.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
      dogminding: imageSharp(
        fluid: { originalName: { regex: "/dog-minding.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
      company: imageSharp(
        fluid: { originalName: { regex: "/company.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  `);

  const data = [
    {
      slug: t('category-section.categories.babysitting.slug'),
      title: t('category-section.categories.babysitting.title'),
      shortDescription: t('category-section.categories.babysitting.shortDescription'),
      image: images.babysitting,
    },
    {
      slug: t('category-section.categories.dog-minding.slug'),
      title: t('category-section.categories.dog-minding.title'),
      shortDescription: t('category-section.categories.dog-minding.shortDescription'),
      image: images.dogminding,
    },
    {
      slug: t('category-section.categories.event.slug'),
      title: t('category-section.categories.event.title'),
      shortDescription: t('category-section.categories.event.shortDescription'),
      image: images.event,
    },
    {
      slug: t('category-section.categories.homework.slug'),
      title: t('category-section.categories.homework.title'),
      shortDescription: t('category-section.categories.homework.shortDescription'),
      image: images.homework,
    },
    {
      slug: t('category-section.categories.gardening.slug'),
      title: t('category-section.categories.gardening.title'),
      shortDescription: t('category-section.categories.gardening.shortDescription'),
      image: images.gardening,
    },
    {
      slug: t('category-section.categories.company.slug'),
      title: t('category-section.categories.company.title'),
      shortDescription: t('category-section.categories.company.shortDescription'),
      image: images.company,
      isCompany: true,
    },
  ];

  return (
    <Section>
      <Heading>{t('category-section.heading')}</Heading>
      <CategoryList categories={data} />
    </Section>
  );
};

const Section = styled.section`
  grid-column: center-start / center-end;

  @media ${device.mobileL} {
    grid-column: full-start / full-end;
  }
`;

const Heading = styled.h2`
  margin-bottom: 3rem;

  @media ${device.mobileL} {
    padding-left: 3rem;
  }
`;

export default CategorySection;
